import React from "react"

function AttachmentIcon(props) {
	return (
		<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M14.3294 7.25832L7.55294 14.0348C6.25069 15.337 4.14115 15.337 2.8389 14.0348C1.53664 12.7325 1.53664 10.623 2.8389 9.32071L10.2046 1.95502C11.0178 1.14184 12.3377 1.14184 13.1509 1.95502C13.964 2.76819 13.964 4.08812 13.1509 4.9013L6.96369 11.0885C6.6396 11.4126 6.10927 11.4126 5.78518 11.0885C5.46109 10.7644 5.46109 10.2341 5.78518 9.90997L11.3831 4.31204L10.4992 3.42816L4.90129 9.02609C4.08812 9.83926 4.08812 11.1592 4.90129 11.9724C5.71447 12.7855 7.0344 12.7855 7.84757 11.9724L14.0348 5.78518C15.337 4.48292 15.337 2.37339 14.0348 1.07113C12.7325 -0.231121 10.623 -0.231121 9.32071 1.07113L1.95502 8.43683C0.163678 10.2282 0.163679 13.1273 1.95502 14.9186C3.74635 16.71 6.64549 16.71 8.43683 14.9186L15.2133 8.1422L14.3294 7.25832Z"
				fill="#475163"
			/>
		</svg>
	)
}

export default AttachmentIcon
